// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./btn_continue_wb.png");
var dir = previousRequest.replace("btn_continue_wb.png", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "btn_continue_wb.png",
	name: "btn_continue_wb",
	ext: ".png",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/btn_continue_wb.png
// module id = 1024
// module chunks = 4